import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { List } from 'immutable'
import { connect } from 'react-redux'
import { compose, withState, withHandlers, withProps } from 'recompose'

import * as channelTypes from 'remote/channels/types'
import { record as UsersRecord, selectors as UsersSelectors } from 'data/users'

import {
  providesChannelMutations,
  providesPublicChannelQuery,
} from './dataSync'
import { Input } from 'components/Utils/Form'
import { Toggle } from 'components/base'
import UsersPicker from 'components/Users/UsersPicker'

import { Button, Text } from 'components/base'
import ModalBody from 'components/Utils/Modal/Body'

const DESCRIPTIONS = {
  [channelTypes.PUBLIC]: {
    label: 'open',
    subtitle: 'Your entire team can view docs in this channel.',
  },
  [channelTypes.PRIVATE]: {
    label: 'private',
    subtitle: 'Only specific team members can access docs in this channel.',
  },
}

class ChannelsClone extends Component {
  static propTypes = {
    cloneChannel: PropTypes.func.isRequired,
    onModalClose: PropTypes.func,
    viewer: PropTypes.instanceOf(UsersRecord).isRequired,
    channelType: PropTypes.number,
  }

  state = {
    errorChannelName: false,
    name: '',
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.publicChannelName !== nextProps.publicChannelName) {
      this.setState({ name: nextProps.publicChannelName })
    }
  }

  render() {
    const { errorChannelName } = this.state
    const {
      channelType,
      toggleChannelType,
      userIds,
      addUserId,
      removeUserId,
      viewer,
      publicChannelName,
    } = this.props
    const { subtitle } = DESCRIPTIONS[channelType]
    return (
      <ModalBody>
        <Text.Title className="margin-bottom-normal">
          {publicChannelName ? `Clone ${publicChannelName} channel` : ''}
        </Text.Title>
        <Text.Corpus className="margin-bottom-larger">
          All docs of this channel template will belong to your team. All
          further edits will only be visible by your team.
        </Text.Corpus>

        <Text.Name className="margin-bottom-normal">
          Edit channel name
        </Text.Name>
        <Input
          value={this.state.name}
          onChange={this.setName}
          onKeyDown={this.onKeyDown}
          group="right"
          className="width-full margin-bottom-normal"
          required
          autoFocus
          placeholder="Enter a channel name"
          tabIndex="-1"
        />
        {errorChannelName && (
          <div className="red margin-bottom-normal">{errorChannelName}</div>
        )}

        <div className="margin-bottom-larger flexbox flexbox-align-center">
          <Toggle
            checked={channelType === channelTypes.PUBLIC}
            onChange={toggleChannelType}
            labels={{ checked: 'Open', unchecked: 'Private' }}
          />
          <Text.SmallDetail className="margin-left-normal">
            {subtitle}
          </Text.SmallDetail>
        </div>

        {channelType !== channelTypes.PUBLIC && (
          <div>
            <Text.Name className="margin-bottom-normal">
              Invite team members to this channel
            </Text.Name>
            <div
              style={{ maxHeight: 'calc(100vh - 300px)' }}
              className="scroll-y margin-bottom-normal"
            >
              <UsersPicker
                ref={ref => {
                  this.usersPicker = ref
                }}
                autoFocus={false}
                currentUserId={viewer.id}
                selectedUserIds={userIds}
                onUserIdSelected={addUserId}
                onUserIdDeselected={removeUserId}
              />
            </div>
          </div>
        )}

        <div className="flexbox margin-top-large">
          <Button.Secondary onClick={this.onDiscard}>Cancel</Button.Secondary>
          <div className="margin-left-auto">
            <Button.Primary onClick={this.onValidate}>
              Create {DESCRIPTIONS[channelType].label} channel
            </Button.Primary>
          </div>
        </div>
      </ModalBody>
    )
  }

  setName = e => {
    this.setState({ name: e.target.value })
  }

  onKeyDown = event => {
    // onEnter
    if (this.state.name.length > 0 && event.keyCode === 13) {
      this.onValidate(event)
    }
  }

  onValidate = event => {
    event.preventDefault()

    const { channelType, userIds, publicShareToken, cloneChannel } = this.props
    const type = channelType === channelTypes.PUBLIC ? 'public' : 'private'

    const cleanedName = this.state.name.trim()
    if (!cleanedName) {
      this.setState({ errorChannelName: "Name can't be empty" })
      return
    }
    cloneChannel({
      publicShareToken,
      type,
      userIds,
      name: this.state.name,
    })
  }

  onDiscard = () => {
    this.props.onModalClose()
  }
}

const mapStateToProps = state => ({
  viewer: UsersSelectors.getCurrentUser(state),
})

export default compose(
  providesPublicChannelQuery,
  providesChannelMutations,
  connect(mapStateToProps),
  withState('userIds', 'setUserIds', List()),
  withProps(({ setUserIds, userIds }) => ({
    addUserId: id => setUserIds(userIds.push(id)),
    removeUserId: id => setUserIds(userIds.filter(userId => userId !== id)),
  })),
  withState('channelType', 'setChannelType', channelTypes.PUBLIC),
  withHandlers({
    toggleChannelType: ({ setChannelType, channelType }) => () =>
      setChannelType(
        channelType === channelTypes.PRIVATE
          ? channelTypes.PUBLIC
          : channelTypes.PRIVATE
      ),
  })
)(ChannelsClone)
